<template>
  <div v-if="showFold">
    <Subtitle :subtitle="mainObj.subTitle" style="height: 9%; padding-top: 3%" />
    <div class="boxMain" style="height: 89%; padding-top: 1%">
      <flightDetails :subData="mainObj.subData" />
    </div>
  </div>
</template>

<script>
import Subtitle from "@/components/header/subTitle.vue";
import flightDetails from "./flightDetails.vue";
export default {
  props: {
    mainObj: {
      typeof: Object,
    },
  },
  components: {
    Subtitle,
    flightDetails,
  },
  data() {
    return {
      showFold: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    open() {
      this.showFold = true;
    },
    close() {
      this.showFold = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
